<template>
  <pt-integral-goods-table class="pt-integral-goods-table__withData" :tableLabels="tableLabels" @getTableData="getTableData" :pageSize="pageSize"
  :totalNumber="totalNumber" :tableData="tableData" ref="table">
  <slot/>
  </pt-integral-goods-table>
</template>

<script>
import PtIntegralGoodsTable from './index'
export default {
  name: 'pt-integral-goods-table__withData',
  components: {
    'pt-integral-goods-table': PtIntegralGoodsTable
  },
  props: {
    tableLabels: {
      type: Array
    },
    paramsData: Object,
    pageSize: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: null
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getGoodsList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getGoodsList(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
    //   this.page = page
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: this.pageSize,
          sort: ['putOnSaleTime,desc', 'id,desc']
        }
      }

      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getInsterGoodsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取商品列表失败')
      })
    }
  }
}
</script>
